module.exports = __webpack_public_path__ + "static/media/WordPress_logo.de3cfeb0.png";